export var actionKey = '@@GROUPS';
//# sourceMappingURL=constants.js.map